/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/ingestion_jobs-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/ingestion_jobs-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/ingestion_jobs-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-ingestion_jobs-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/ingestion_jobs.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/ingestion_jobs-entity-config.ts
 * Public fields: 24/24 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const IngestionJobsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  data_source_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // data_source_id field
  triggered_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // triggered_by_user_profile_id field
  job_type_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_type_id field
  job_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_status_id field
  job_name: Type.Union([Type.String(), Type.Null()]), // job_name field
  started_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // started_at field
  completed_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // completed_at field
  error_log: Type.Union([Type.String(), Type.Null()]), // error_log field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  trust_rank_override: Type.Union([Type.Number(), Type.Null()]), // trust_rank_override field
  skip_review: Type.Boolean(), // skip_review field
  auto_approve_started_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // auto_approve_started_at field
  auto_approve_completed_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // auto_approve_completed_at field
  auto_approve_total: Type.Number(), // auto_approve_total field
  auto_approve_completed: Type.Number(), // auto_approve_completed field
  auto_approve_failed: Type.Number(), // auto_approve_failed field
  auto_approve_errors: Type.Any(), // auto_approve_errors field
  rollback_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // rollback_status_id field
  rolled_back_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // rolled_back_at field
  rolled_back_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // rolled_back_by_user_profile_id field
  rollback_reason: Type.Union([Type.String(), Type.Null()]), // rollback_reason field
  skip_transaction_records: Type.Boolean(), // skip_transaction_records field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
});

export const CreateIngestionJobsSchema = Type.Object({
  data_source_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // data_source_id field
  triggered_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // triggered_by_user_profile_id field
  job_type_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // job_type_id field
  job_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // job_status_id field
  job_name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // job_name field
  started_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // started_at field
  completed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // completed_at field
  error_log: Type.Optional(Type.Union([Type.String(), Type.Null()])), // error_log field
  trust_rank_override: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // trust_rank_override field
  skip_review: Type.Optional(Type.Boolean()), // skip_review field
  auto_approve_started_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // auto_approve_started_at field
  auto_approve_completed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // auto_approve_completed_at field
  auto_approve_total: Type.Optional(Type.Number()), // auto_approve_total field
  auto_approve_completed: Type.Optional(Type.Number()), // auto_approve_completed field
  auto_approve_failed: Type.Optional(Type.Number()), // auto_approve_failed field
  auto_approve_errors: Type.Optional(Type.Any()), // auto_approve_errors field
  rollback_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // rollback_status_id field
  rolled_back_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // rolled_back_at field
  rolled_back_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // rolled_back_by_user_profile_id field
  rollback_reason: Type.Optional(Type.Union([Type.String(), Type.Null()])), // rollback_reason field
  skip_transaction_records: Type.Optional(Type.Boolean()), // skip_transaction_records field
});

export const UpdateIngestionJobsSchema = Type.Object({
  data_source_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // data_source_id field
  triggered_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // triggered_by_user_profile_id field
  job_type_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // job_type_id field
  job_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // job_status_id field
  job_name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // job_name field
  started_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // started_at field
  completed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // completed_at field
  error_log: Type.Optional(Type.Union([Type.String(), Type.Null()])), // error_log field
  trust_rank_override: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // trust_rank_override field
  skip_review: Type.Optional(Type.Boolean()), // skip_review field
  auto_approve_started_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // auto_approve_started_at field
  auto_approve_completed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // auto_approve_completed_at field
  auto_approve_total: Type.Optional(Type.Number()), // auto_approve_total field
  auto_approve_completed: Type.Optional(Type.Number()), // auto_approve_completed field
  auto_approve_failed: Type.Optional(Type.Number()), // auto_approve_failed field
  auto_approve_errors: Type.Optional(Type.Any()), // auto_approve_errors field
  rollback_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // rollback_status_id field
  rolled_back_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // rolled_back_at field
  rolled_back_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // rolled_back_by_user_profile_id field
  rollback_reason: Type.Optional(Type.Union([Type.String(), Type.Null()])), // rollback_reason field
  skip_transaction_records: Type.Optional(Type.Boolean()), // skip_transaction_records field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type IngestionJobsRow = Static<typeof IngestionJobsSchema>;
export type IngestionJobsInsert = Static<typeof CreateIngestionJobsSchema>;
export type IngestionJobsUpdate = Static<typeof UpdateIngestionJobsSchema>;

// Legacy type aliases for backward compatibility
export type IngestionJobs = IngestionJobsRow;
export type CreateIngestionJobs = IngestionJobsInsert;
export type UpdateIngestionJobs = Static<typeof UpdateIngestionJobsSchema>;

// Field configuration metadata
export const IngestionJobsFieldConfig = {
  filterable: ['id', 'data_source_id', 'triggered_by_user_profile_id', 'job_type_id', 'job_status_id', 'rollback_status_id', 'rolled_back_by_user_profile_id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'skip_review', 'auto_approve_total', 'auto_approve_completed', 'auto_approve_failed', 'auto_approve_errors', 'skip_transaction_records', 'updated_at'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface IngestionJobsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface IngestionJobsResponse {
  data: IngestionJobs[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleIngestionJobsResponse {
  data: IngestionJobs | null;
  error: Error | null;
}
